import { memo, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";
import Lomake from "@/components/02-organisms/Lomake";
import { omit } from "ramda";
import equal from "react-fast-compare";
import { useChangeObjectsByAnchorWithoutUnderRemoval } from "@/stores/muutokset";
import education from "@/i18n/definitions/education";
import wizard from "@/i18n/definitions/wizard";
import { PaikallisenTietovarastonAvain } from "@/enums";
import localForage from "localforage";

const constants = {
  mode: "modification",
  formLocation: ["taiteenPerusopetus", "luvanTaiteenalat"]
};

const LuvanTaiteenalat = memo(
  ({
    code,
    isPreviewModeOn,
    maaraykset,
    mode = constants.mode,
    rajoitteet,
    sectionId
  }) => {
    const intl = useIntl();
    const [changeObjects] = useChangeObjectsByAnchorWithoutUnderRemoval({
      anchor: sectionId
    });
    const [koodisto, setKoodisto] = useState();
    const title = intl.formatMessage(wizard.luvanTaiteenalat);
    /** Haetaan muistista luvan taiteenalojen koodisto */
    useEffect(() => {
      localForage
        .getItem(PaikallisenTietovarastonAvain.LUVAN_TAITEENALAT_KOODISTO_TPO)
        .then(koodisto => {
          setKoodisto(koodisto);
        })
        .catch(err => {
          console.error(err);
        });
    }, []);

    return koodisto ? (
      <Lomake
        anchor={sectionId}
        changeObjects={changeObjects}
        code={code}
        data={{ maaraykset, rajoitteet }}
        formTitle={title}
        mode={mode}
        isPreviewModeOn={isPreviewModeOn}
        isRowExpanded={true}
        path={constants.formLocation}
        rowTitle={intl.formatMessage(education.taiteenPerusopetus)}
        showCategoryTitles={true}></Lomake>
    ) : null;
  },
  (cp, np) => {
    return equal(omit(["functions"], cp), omit(["functions"], np));
  }
);

LuvanTaiteenalat.propTypes = {
  code: PropTypes.string,
  isPreviewModeOn: PropTypes.bool,
  maaraykset: PropTypes.array,
  mode: PropTypes.string,
  rajoitteet: PropTypes.object,
  sectionId: PropTypes.string
};

LuvanTaiteenalat.displayName = "LuvanTaiteenalat";

export default LuvanTaiteenalat;
